"use client";

import { TimelineEvent } from "@ui/components/core/InteractiveTimelineUI";
import dynamic from "next/dynamic";

const InteractiveTimeline = dynamic(() =>
  import("@ui/components/core/InteractiveTimelineUI").then(mod => mod.InteractiveTimelineUI),
);

export const InteractiveTimelineWrapper = (props: { title: string; events: TimelineEvent[] }) => {
  return <InteractiveTimeline {...props} />;
};
